import useTranslation from '@/hooks/i18n';
import classNames from 'classnames';

export default function DefaultContentTemplateTags({
  tags,
  className,
  duration,
  isDefaultContentTemplate = false,
}: {
  tags: string[];
  className?: string;
  duration?: string;
  isDefaultContentTemplate?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('flex flex-wrap gap-4', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}>
      {tags
        ?.filter((t) => t !== '')
        .map((tag) => {
          return (
            <div
              key={tag}
              className="flex items-center justify-center rounded-2xl border border-[#EEEEEE] bg-white px-[10px] py-[5px] text-black">
              <span className="my-0 text-sh-14-16">{t(tag)}</span>
              {duration && (
                <>
                  <img src="/icons/clock.svg" className="mx-1 inline-block h-4 w-4" alt="Clock" />{' '}
                  <span className="text-sh-14-16">{duration}</span>
                </>
              )}
            </div>
          );
        })}
    </div>
  );
}
